import { buttonNextTrackId, buttonPreviousTrackId } from "Utils/analytics";

import { ButtonsWrap } from "App/global-style";
import { useUpsellFeature } from "Components/Features/Upsell/hooks/useUpsellFeature";
import { useTexts } from "Components/TextContext";
import { Button } from "Components/TextContext/commonComponentEnums";
import { ThemedButton } from "Components/Themes/components/ThemedButton";
import { prevStep } from "Store/steps/stepsSlice";
import { isDefined } from "Utils/functions";
import React from "react";
import { useDispatch } from "react-redux";
import { handleButtonClick } from "./navigationButtonUtils";
import { NavigationButtonsProps } from "./navigationButtonsTypes";

export const NavigationButtons = ({
  customNextButtonText,
  customPrevButtonText,
  hidePreviousButton = false,
  disableNextButton = false,
  nextButtonOnClick,
  prevButtonOnClick,
  isLoading = false,
  isUpsell = false,
}: NavigationButtonsProps): React.ReactElement => {
  const isUpsellActive = useUpsellFeature();
  const dispatch = useDispatch();
  const { getText } = useTexts();

  const isUpsellText =
    isUpsell && isUpsellActive ? "Legg i handlekurv" : customNextButtonText;

  const nextText = isUpsellText ?? getText(Button.NEXT);
  const prevText = customPrevButtonText ?? getText(Button.PREVIOUS);

  const handlePreviousButtonClick = (): void => {
    dispatch(prevStep());
    isDefined(prevButtonOnClick) && prevButtonOnClick();
  };

  return (
    <ButtonsWrap className="NavigationButtons" role="navigation">
      <ThemedButton
        id="button-next"
        className="NextButton"
        disabled={disableNextButton}
        type="submit"
        trackId={buttonNextTrackId(nextText)}
        loading={isLoading}
        onClick={(event) => handleButtonClick(event, nextButtonOnClick)}
      >
        {nextText}
      </ThemedButton>
      {!hidePreviousButton && (
        <ThemedButton
          id="button-previous"
          className="PreviousButton"
          type="button"
          trackId={buttonPreviousTrackId(prevText)}
          variant="text"
          onClick={(event) =>
            handleButtonClick(event, handlePreviousButtonClick)
          }
        >
          {prevText}
        </ThemedButton>
      )}
    </ButtonsWrap>
  );
};
